import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

function Numbered({ n, title, accent, children }) {
  return (
    <div className="flex gap-3 mb-4">
      <p className="text-3xl font-black leading-none" style={{ color: `${accent}30` }}>{n}</p>
      <div className="flex-1">
        <h2 className="text-xs font-bold uppercase tracking-wider mb-1" style={{ color: accent }}>{title}</h2>
        {children}
      </div>
    </div>
  );
}

export default function NumberedSectionsTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
      {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
      <p className="text-slate-500 text-[11px] mt-2 mb-5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>

      {draft.summary && <Numbered n="01" title="Summary" accent={accent}><p className="text-slate-700">{draft.summary}</p></Numbered>}
      {draft.experience.length > 0 && (
        <Numbered n="02" title="Experience" accent={accent}>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </Numbered>
      )}
      {draft.education.length > 0 && (
        <Numbered n="03" title="Education" accent={accent}>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </Numbered>
      )}
      {draft.skills.length > 0 && (
        <Numbered n="04" title="Skills" accent={accent}><p className="text-slate-700">{draft.skills.join(", ")}</p></Numbered>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
